var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-description',{attrs:{"path":[
        {label: _vm.$t('data.gestion_menu_mes_occupations'), route: 'occupations'}, 
    ]}}),(_vm.path == '')?_c('occupations'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }